import React from 'react';
import { Wrapper, SubLinks, LinkWrapper, PageLink, MainCategoryText, MainCategory } from './index.style';
import { MAIN_PAGES } from '../../constants';
import { FooterAnalyticsContext } from '../utils/analytics';

export interface MainPagesProps {
  params?: string;
}

export const MainPages: React.FC<MainPagesProps> = ({ params = '' }) => {
  const { analyticsForFooter } = React.useContext(FooterAnalyticsContext);

  return (
    <Wrapper>
      {MAIN_PAGES.map((link) => (
        <MainCategory key={link.category}>
          <MainCategoryText href={`${link.categoryURL}${params}`} onClick={() => analyticsForFooter(link.category)}>
            {link.category}
          </MainCategoryText>
          <SubLinks>
            {link.pageList.map((subpage) => (
              <LinkWrapper key={subpage.label}>
                <PageLink href={`${subpage.url}${params}`} onClick={() => analyticsForFooter(subpage.label)}>
                  {subpage.label}
                </PageLink>
              </LinkWrapper>
            ))}
          </SubLinks>
        </MainCategory>
      ))}
    </Wrapper>
  );
};
